import { Component } from '@angular/core';

import {
  CamExpansionPanelComponent,
  CamStatusSelectComponent,
  CamWrappedIconComponent,
  ColorSetDisplayerComponent,
  FileImageComponent,
  LogoComponent,
  NotificationBadgeComponent,
  NotificationBadgeContainerComponent,
  PictureInfoMessageComponent,
  SectionLayoutComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CamExpansionPanelComponent,
        CamStatusSelectComponent,
        CamWrappedIconComponent,
        ColorSetDisplayerComponent,
        FileImageComponent,
        LogoComponent,
        NotificationBadgeComponent,
        NotificationBadgeContainerComponent,
        PictureInfoMessageComponent,
        SectionLayoutComponent,
        TestIdDirective,
    ],
    template: `
    <cam-color-set-displayer camTestId="cam-color-set-displayer" [colorSet]="this.colorSet" />
    <cam-expansion-panel camTestId="cam-expansion-panel" />
    <cam-section-layout camTestId="cam-section-layout" title="Section title">section content</cam-section-layout>
    <cam-file-image camTestId="cam-file-image" fileName="report.pdf" />
    <cam-logo camTestId="cam-logo" />
    <cam-notification-badge-container camTestId="cam-notification-badge-container">
      <cam-notification-badge camTestId="cam-notification-badge" [relative]="true" [number]="3" />
    </cam-notification-badge-container>
    <cam-picture-info-message camTestId="cam-picture-info-message" />
    <cam-status-select camTestId="cam-status-select" label="Open" icon="edit">
      <ng-template #statusMenu>
        <div>menu content</div>
      </ng-template>
    </cam-status-select>
    <cam-wrapped-icon camTestId="cam-wrapped-icon" icon="edit" />
  `
})
export class UiMiscCase {
  public colorSet = { backgroundColor: '#ffffff', borderColor: '#ff0000', textColor: '#000000' };
}
